import EventCard from "./EventCard";
import Data from "../data/non_technical.json";
import Slider from "./Slider";

const NonTechnical = () => {

	const words = ["NONTECHNICAL", "*", <p className="font-bold">NONTECHNICAL</p>,"*", "NONTECHNICAL", "*", <p className="font-bold">NONTECHNICAL</p>, "*", "NONTECHNICAL", "*", <p className="font-bold">NONTECHNICAL</p>, "*",];

	return (
		<div className="pt-24">
			<Slider words={words}/>
			<div className="flex flex-wrap justify-center py-10">
			{// Map each tech talk into an EventCard component
			Object.keys(Data).map((key) => {
				return (
					<EventCard
						id={key}
						title={Data[key].title}
						desc={Data[key].desc}
						price={Data[key].price}
						logo_url={Data[key].logo_url}
					/>
					);
				})}
			</div>
			<Slider words={words}/>
		</div>
	);
};

export default NonTechnical;
